import { getLocale } from "../runtime";

const sv_iecountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Irland`
};

const iecountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_iecountry(inputs)
	return "ieCountry";
};

export { iecountry as "ieCountry" };